import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  registryRights: [],
  availableStatuses: null,
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:vacation.index" },
      {
        key: "createdBy.firstName, createdBy.lastName",
        name: "global:vacation.createdBy",
      },
      { key: "vacationType.entryName", name: "global:vacation.vacationType" },

      { key: "status.name", name: "global:vacation.status" },
      {
        key: "responsible.firstName,responsible.lastName",
        name: "global:vacation.responsible",
      },
    ],
    selectedSearchFields: ["index"],
    dictionaryFields: ["vacationType"],
    url: "vacation",
  },
};

const vacationReducer = createSlice({
  name: "vacationReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = vacationReducer.actions;

export default vacationReducer.reducer;
